import * as Yup from "yup";
import React, { useMemo, useState } from "react";
import { AiOutlineInfoCircle } from "react-icons/ai";
import { FiAtSign, FiEdit } from "react-icons/fi";
import { Formik } from "formik";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";

import ContainedButton from "components/layout/form/containedButton";
import MailingAddress from "components/MI/adicionar-unidade/MailingAddress";
import ModalEmailConfirm from "./EmailConfirm";
import RadioField from "components/layout/form/radioField";
import TextField from "components/layout/form/textField";
import api from "services/api";
import { isObjectEmpty } from "utils/functions";
import {
  setUnitsList,
  toggleSelectedUnit,
} from "store/actions/select-unit-actions";

import theme from "styles/theme";
import {
  Action,
  Alert,
  AlertIcon,
  Badge,
  ButtonsContainer,
  Container,
  CorrespondetionSection,
  DaySection,
  EmailSection,
  Error,
  FormContainer,
  Info,
  InfoContent,
  InputsContainer,
  Label,
  MailSection,
  Messenger,
  TextBlockEmail,
  TextImpactAmbient,
  TitleImpactAmbient,
  TooltipTextImpactAmbient,
} from "./styles";

const BillingData = (): JSX.Element => {
  const [openSwitchAddressModal, setOpenSwitchAddressModal] =
    useState<boolean>();
  const [addressShipLetterTo, setAddressShipLetterTo] = useState<any>();
  const [email, setEmail] = useState(
    localStorage.getItem("@UltragazEmpresarial:loginEmail") || ""
  );
  const [editForm, setEditForm] = useState<boolean>();
  const [loading, setLoading] = useState<boolean>();
  const [buttonTxt, setButtonTxt] = useState("Atualizar");
  const [openEmailConfirmModal, setOpenEmailConfirmModal] = useState<boolean>();
  const [alertInvoiceDigital, setAlertInvoiceDigital] = useState("");
  const [showFieldsEmail, setShowFieldsEmail] = useState(true);
  const dispatch = useDispatch();
  const { selectedUnit, unitsList } = useSelector((state) => ({
    // @ts-ignore
    selectedUnit: state.selectUnitReducer.selectedUnit,
    // @ts-ignore
    unitsList: state.selectUnitReducer.unitsList,
  }));
  const [dueDay, setDueDay] = useState(selectedUnit.dueDay);
  const [invoiceType, setInvoiceType] = useState(selectedUnit.deliveryType);

  const addressShipTo = selectedUnit?.address?.find(
    (e) => e.addressType === "SHIP_TO"
  );

  const addressShipLetterToFilter = useMemo(() => {
    const { address } = selectedUnit;
    const addressShipLetterToFind = address.find(
      (ad) => ad.addressType === "SHIP_LETTER_TO"
    );
    const addressShipToFind = address.find(
      (ad) => ad.addressType === "SHIP_TO"
    );
    if (selectedUnit && selectedUnit.address.length > 0) {
      return addressShipLetterToFind || addressShipToFind || {};
    }
    return {};
  }, [selectedUnit]);

  const getAddress = (address: any): string => {
    let fullAddress = "";

    if (address.address || address.fullAddress) {
      fullAddress += address.address || address.fullAddress;
    }

    if (address.number) {
      fullAddress += `, ${address.number}`;
    }

    if (address.complement) {
      fullAddress += `, ${address.complement}`;
    }

    if (address.neighborhood) {
      fullAddress += `, ${address.neighborhood}`;
    }

    if (address.city) {
      fullAddress += `, ${address.city}`;
    }

    if (address.stateCode) {
      fullAddress += ` - ${address.stateCode}`;
    }

    return fullAddress;
  };

  const getNewAddress = (): JSX.Element => {
    setButtonTxt("Atualizar");

    if (addressShipLetterTo) {
      return (
        <>
          <Badge>Novo endereço de cobrança</Badge>
          <CorrespondetionSection>
            <p>{getAddress(addressShipLetterTo)}</p>
          </CorrespondetionSection>
        </>
      );
    }

    return (
      <InfoContent>
        <div>
          <Label as="div">Endereço de correspondência atual:</Label>
          <Info>{getAddress(addressShipLetterToFilter)}</Info>
        </div>
        {selectedUnit.hasCurrentHouseholder ? (
          <Action>
            <FiEdit onClick={() => setOpenSwitchAddressModal(true)} />
          </Action>
        ) : null}
      </InfoContent>
    );
  };

  const updateToEditEmail = (): void => {
    setInvoiceType("EMAIL");
    setEmail(null);
  };

  const getEmailSection = (
    values,
    errors,
    touched,
    handleBlur,
    handleChange
  ): JSX.Element => {
    if (values.email && !editForm) {
      return (
        <>
          <TextBlockEmail>
            Você já possui um e-mail cadastrado. Ao alterar o e-mail de
            cobrança, será atualizado seu e-mail em Dados Pessoais.
          </TextBlockEmail>

          <InfoContent>
            <div>
              <Label as="div">E-mail cadastrado:</Label>
              <Info>{values.email}</Info>
            </div>
            {selectedUnit.hasCurrentHouseholder ? (
              <Action>
                <FiEdit
                  onClick={() => {
                    updateToEditEmail();
                    setDueDay(values.dueDay);
                  }}
                />
              </Action>
            ) : null}
          </InfoContent>
        </>
      );
    }

    if (buttonTxt === "Atualizar") setButtonTxt("Alterar e-mail");

    if (alertInvoiceDigital) setButtonTxt("Já verifiquei");

    return (
      <>
        <p>
          O e-mail será validado através do link enviado. As alterações
          solicitadas serão efetuadas em até 01 (um) mês. O e-mail informado
          também irá alterar o e-mail de Dados Cadastrais.
        </p>

        {alertInvoiceDigital && (
          <Alert>
            <AlertIcon />
            {alertInvoiceDigital}
          </Alert>
        )}

        {showFieldsEmail && (
          <>
            <div>
              <TextField
                LeadingIcon={FiAtSign}
                propsLeadingIcon={{
                  size: 24,
                  color: "#c1c1c1",
                }}
                type="email"
                name="email"
                label="Digite seu e-mail"
                value={values.email}
                errorCondition={errors.email && touched.email}
                errorMessage={errors.email}
                onBlur={handleBlur}
                onChange={(e) => {
                  handleChange(e);
                  setEditForm(true);
                }}
              />
            </div>

            <Messenger>Será enviado um e-mail para validação</Messenger>

            <div>
              <TextField
                LeadingIcon={FiAtSign}
                propsLeadingIcon={{
                  size: 24,
                  color: "#c1c1c1",
                }}
                type="email"
                name="emailConfirm"
                label="Repita seu e-mail"
                value={values.emailConfirm}
                errorCondition={errors.emailConfirm && touched.emailConfirm}
                errorMessage={errors.emailConfirm}
                onBlur={handleBlur}
                onChange={(e) => {
                  handleChange(e);
                  setEditForm(true);
                }}
              />
            </div>
          </>
        )}
      </>
    );
  };

  const validatorSchema = (): any =>
    Yup.object().shape({
      dueDay: Yup.string().required(
        "É necessário selecionar um dia de vencimento"
      ),
      invoiceType: Yup.string().required(
        "É necessário selecionar um tipo de fatura"
      ),
      email: Yup.string().when("invoiceType", {
        is: (val) => val === "EMAIL",
        then: Yup.string()
          .email("E-mail inválido")
          .required("É necessário digitar um e-mail"),
        otherwise: Yup.string(),
      }),
      emailConfirm: Yup.string().when("invoiceType", {
        is: (val) => val === "EMAIL",
        then: Yup.string()
          .email("E-mail inválido")
          .oneOf([Yup.ref("email")], "Os e-mails não combinam")
          .required("É necessário confirmar o e-mail"),
        otherwise: Yup.string(),
      }),
    });

  const requestPatchCustomers = async (email): Promise<void> => {
    try {
      setLoading(true);
      const headers = {
        access_token: localStorage.getItem("@UltragazEmpresarial:accessToken"),
        EMAIL_CONFIRMATION_URL: `${process.env.REACT_APP_URL}/verificar-email`,
      };
      const body = {
        email,
      };
      await api.patch(`industrial/customer/v1/customers/me`, body, {
        headers,
      });
      setLoading(false);
      setOpenEmailConfirmModal(true);
    } catch (err) {
      setLoading(false);
      const erro = err.response;
      if (erro) {
        const { message } = err.response.data;
        if (err.response.status !== 401) {
          toast.error(message);
        }
      } else if (err.response.status !== 401) {
        toast.error("Ocorreu um erro interno na aplicação");
      }
    }
  };

  const requestPatchUnits = async (
    unitId,
    dueDay,
    invoiceType,
    address,
    email,
    selectedUnit
  ): Promise<void> => {
    const newDatesUnits = {
      dueDay,
      invoiceType,
    };

    const oldDatesUnits = {
      dueDay: selectedUnit.dueDay,
      invoiceType: selectedUnit.deliveryType,
    };

    try {
      if (invoiceType === "EMAIL") {
        const headers = {
          access_token: localStorage.getItem(
            "@UltragazEmpresarial:accessToken"
          ),
        };

        const userIdLocalStorage = localStorage.getItem(
          "@UltragazEmpresarial:userId"
        );

        const validedContact = await api.get(
          `industrial/customer/v1/users/${userIdLocalStorage}/contacts?contactType=EMAIL&contact=${email}&is-contact-validated=true`,
          {
            headers,
          }
        );

        setLoading(false);

        if (validedContact.data.length > 0) {
          setLoading(true);

          const responseDeliveryType = await api.patch(
            `industrial/customer/v1/customers/me/units/${unitId}`,
            {
              dueDay,
              deliveryType: "EMAIL",
              address,
            },
            {
              headers,
            }
          );

          setLoading(false);

          if (responseDeliveryType.status === 204) {
            const findIndex = selectedUnit?.address.findIndex(
              (addr) => addr.addressType === address.addressType
            );

            const newAddress = selectedUnit.address;
            newAddress[findIndex] = address;

            const newSelectedUnit = {
              ...selectedUnit,
              dueDay,
              address: newAddress,
              deliveryType: "EMAIL",
            };
            dispatch(toggleSelectedUnit(newSelectedUnit));

            let message = `Sua fatura digital foi ativada! Você receberá em ${email}`;

            localStorage.setItem("@UltragazEmpresarial:loginEmail", email);

            if (
              newDatesUnits.dueDay !== oldDatesUnits.dueDay &&
              newDatesUnits.invoiceType !== oldDatesUnits.invoiceType
            ) {
              message = "Dia de vencimento e tipo de cobrança alterada";
            } else if (newDatesUnits.dueDay !== oldDatesUnits.dueDay) {
              message = "Dia de vencimento alterado com sucesso";
            }

            toast.success(message);
            setTimeout(() => {
              window.location.reload();
            }, 4200);
          }
        } else {
          toast.warn(`Estamos enviando um e-mail de verificação para ${email}`);

          const bodyContact = {
            contact: email,
            contactType: "EMAIL",
            siteId: localStorage.getItem("@UltragazEmpresarial:customerSiteId"),
          };

          setLoading(true);

          const createContact = await api.post(
            `industrial/customer/v1/users/${userIdLocalStorage}/contacts`,
            bodyContact,
            {
              headers,
            }
          );

          if (createContact.status === 201) {
            const contactId = createContact.headers.location.split("/").pop();

            const urlApp = process.env.REACT_APP_URL;
            const newUrl = `${urlApp}${!urlApp.endsWith("/") ? "/" : ""}`;

            const bodyTokenContact = {
              contactId,
              tokenType: "REGISTER",
              url: `${newUrl}verificar-email`,
            };

            const createTokenContact = await api.post(
              `industrial/customer/v1/users/${userIdLocalStorage}/tokens`,
              bodyTokenContact,
              {
                headers,
              }
            );

            setLoading(false);

            if (createTokenContact.status === 202) {
              setButtonTxt("Já verifiquei");
              setAlertInvoiceDigital(`Um e-mail de validação foi enviado para ${email}.
                Por favor, confirme e clique no botão abaixo:`);
              setShowFieldsEmail(false);
            } else {
              toast.error("Ocorreu um erro interno na aplicação");
            }
          } else {
            toast.error("Ocorreu um erro interno na aplicação");
            setLoading(false);
            return;
          }
        }

        return;
      }

      setLoading(true);
      const headers = {
        access_token: localStorage.getItem("@UltragazEmpresarial:accessToken"),
      };

      const body: any = { dueDay };

      if (newDatesUnits.dueDay !== oldDatesUnits.dueDay) {
        body.dueDay = dueDay;
      }

      if (newDatesUnits.invoiceType !== oldDatesUnits.invoiceType) {
        body.deliveryType = invoiceType;
      }

      if (address && address.addressType) {
        body.address = address;
      }

      if (!isObjectEmpty(body)) {
        await api.patch(
          `industrial/customer/v1/customers/me/units/${unitId}`,
          body,
          {
            headers,
          }
        );

        const newSelectedUnit = { ...selectedUnit };

        if (body.dueDay) {
          newSelectedUnit.dueDay = body.dueDay;
        }

        if (body.deliveryType) {
          newSelectedUnit.deliveryType = body.deliveryType;
        }
        if (body.address && body.address.addressType) {
          const addressIndex = newSelectedUnit.address.findIndex(
            (ad) => ad.addressType === "SHIP_LETTER_TO"
          );
          if (addressIndex >= 0) {
            newSelectedUnit.address[addressIndex] = body.address;
          } else {
            newSelectedUnit.address.push(body.address);
          }
        }
        let newUnitsList = [...unitsList];
        newUnitsList = newUnitsList.map((unitF) => {
          if (unitF.unitId === newSelectedUnit.unitId) {
            unitF = newSelectedUnit;
          }
          return unitF;
        });
        dispatch(toggleSelectedUnit(newSelectedUnit));
        dispatch(setUnitsList(newUnitsList));

        setLoading(false);

        if (editForm) {
          requestPatchCustomers(email);
        } else {
          setOpenEmailConfirmModal(true);
        }
      } else {
        if (editForm) {
          requestPatchCustomers(email);
        }
        setLoading(false);
      }
    } catch (err) {
      setLoading(false);
      const erro = err.response;
      if (erro) {
        const { message } = err.response.data;
        if (err.response.status !== 401) {
          toast.error(message);
        }
      } else {
        const status = err.response?.status || false;
        if (status !== 401) {
          toast.error("Ocorreu um erro interno na aplicação");
        }
      }
    }
  };

  const updateCobranca = (dueDay, invoiceType, email): void => {
    setLoading(true);
    setInvoiceType(invoiceType);
    setEmail(email);

    const address = (): any => {
      if (addressShipLetterTo) {
        return {
          address: addressShipLetterTo.address,
          number: addressShipLetterTo.number,
          complement: addressShipLetterTo.complement,
          neighborhood: addressShipLetterTo.neighborhood,
          city: addressShipLetterTo.city,
          stateCode: addressShipLetterTo.stateCode,
          country: "Brasil",
          zipCode: addressShipLetterTo.zipCode,
          addressType: "SHIP_LETTER_TO",
        };
      }

      return {
        ...addressShipTo,
        addressType: "SHIP_LETTER_TO",
        country: "Brasil",
      };
    };

    requestPatchUnits(
      selectedUnit.unitId,
      dueDay,
      invoiceType,
      address(),
      email,
      selectedUnit
    );
  };

  console.log({ invoiceType });

  return (
    <Container>
      <Formik
        initialValues={{
          dueDay: dueDay || "",
          invoiceType: invoiceType || "CORREIO",
          email: email || "",
          emailConfirm: email || "",
        }}
        onSubmit={({ dueDay, invoiceType, email }) => {
          if (!loading) {
            updateCobranca(dueDay, invoiceType, email);
          }
        }}
        validationSchema={validatorSchema}
        enableReinitialize
        render={({ handleChange, handleBlur, values, errors, touched }) => (
          <FormContainer>
            <InputsContainer>
              <DaySection>
                <h1>1 - Selecione o melhor dia para vencimento:</h1>
                <div>
                  <input
                    id="day1"
                    type="radio"
                    name="dueDay"
                    value="1"
                    onBlur={handleBlur}
                    onChange={(e) => {
                      handleChange(e);
                      setDueDay(e.target.value);
                    }}
                    defaultChecked={values.dueDay === 1}
                  />
                  <label htmlFor="day1">1</label>

                  <input
                    id="day3"
                    type="radio"
                    name="dueDay"
                    value="5"
                    onBlur={handleBlur}
                    onChange={(e) => {
                      handleChange(e);
                      setDueDay(e.target.value);
                    }}
                    defaultChecked={values.dueDay === 5}
                  />
                  <label htmlFor="day3">5</label>

                  <input
                    id="day4"
                    type="radio"
                    name="dueDay"
                    value="10"
                    onBlur={handleBlur}
                    onChange={(e) => {
                      handleChange(e);
                      setDueDay(e.target.value);
                    }}
                    defaultChecked={values.dueDay === 10}
                  />
                  <label htmlFor="day4">10</label>

                  <input
                    id="day5"
                    type="radio"
                    name="dueDay"
                    value="15"
                    onBlur={handleBlur}
                    onChange={(e) => {
                      handleChange(e);
                      setDueDay(e.target.value);
                    }}
                    defaultChecked={values.dueDay === 15}
                  />
                  <label htmlFor="day5">15</label>

                  <input
                    id="day6"
                    type="radio"
                    name="dueDay"
                    value="20"
                    onBlur={handleBlur}
                    onChange={(e) => {
                      handleChange(e);
                      setDueDay(e.target.value);
                    }}
                    defaultChecked={values.dueDay === 20}
                  />
                  <label htmlFor="day6">20</label>

                  <input
                    id="day7"
                    type="radio"
                    name="dueDay"
                    value="25"
                    onBlur={handleBlur}
                    onChange={(e) => {
                      handleChange(e);
                      setDueDay(e.target.value);
                    }}
                    defaultChecked={values.dueDay === 25}
                  />
                  <label htmlFor="day7">25</label>
                </div>
                {errors.dueDay && <Error>{`${errors.dueDay}`}</Error>}
              </DaySection>
              <MailSection>
                <h1>2 - Como deseja receber suas correspondências?</h1>
                <div>
                  <div>
                    <RadioField
                      id="digitalInvoce"
                      type="radio"
                      name="invoiceType"
                      value="EMAIL"
                      onBlur={handleBlur}
                      onChange={(e) => {
                        handleChange(e);
                        setInvoiceType(e?.currentTarget?.value);
                      }}
                      defaultChecked={invoiceType === "EMAIL"}
                    />
                    <label htmlFor="digitalInvoce">Fatura digital</label>
                  </div>

                  <div>
                    <RadioField
                      id="postOfficeInvoce"
                      type="radio"
                      name="invoiceType"
                      value="CORREIO"
                      onBlur={handleBlur}
                      onChange={(e) => {
                        handleChange(e);
                        setInvoiceType(e?.currentTarget?.value);
                      }}
                      defaultChecked={invoiceType === "CORREIO"}
                    />
                    <label htmlFor="postOfficeInvoce">Pelo correio</label>
                  </div>
                </div>
                {errors.invoiceType &&
                  touched.invoiceType &&
                  errors.invoiceType && (
                    <Error>{`${errors.invoiceType}`}</Error>
                  )}
              </MailSection>

              {values.invoiceType === "EMAIL" && (
                <EmailSection>
                  {getEmailSection(
                    values,
                    errors,
                    touched,
                    handleBlur,
                    handleChange
                  )}
                </EmailSection>
              )}

              {values.invoiceType === "CORREIO" && (
                <>
                  <TitleImpactAmbient>Tem certeza?</TitleImpactAmbient>
                  <TextImpactAmbient
                    data-tip="impacto-meio-ambiente"
                    data-for="impacto-meio-ambiente"
                  >
                    Veja o impacto ao meio ambiente!
                    <AiOutlineInfoCircle />
                    <TooltipTextImpactAmbient
                      id="impacto-meio-ambiente"
                      place="top"
                      type="dark"
                      effect="solid"
                      offset={{
                        left: 10,
                        right: 10,
                        top: 10,
                        bottom: 10,
                      }}
                      arrowColor={theme.colors.blueClean}
                      backgroundColor={theme.colors.blueClean}
                      textColor={theme.colors.blue}
                    >
                      <p>Impacto ao meio ambiente</p>
                      <ul>
                        <li>Derrubadas de mais árvores</li>
                        <li>Aumento da poluição</li>
                        <li>Gasto com transporte para a entrega</li>
                        <li>Gasto de água para fabricação</li>
                        <li>Gasto de outros materiais complementares</li>
                      </ul>
                      <img
                        src="/static/icon-ambiente.png"
                        alt="Icon Ambiente"
                      />
                    </TooltipTextImpactAmbient>
                  </TextImpactAmbient>
                  {getNewAddress()}
                  <TextImpactAmbient>
                    <a
                      href="https://buscacepinter.correios.com.br/app/localidade_logradouro/index.php"
                      target="_blank"
                      rel="noreferrer"
                    >
                      Não sei meu CEP
                    </a>
                    <AiOutlineInfoCircle
                      data-tip="nao-sei-meu-cep"
                      data-for="nao-sei-meu-cep"
                    />
                    <TooltipTextImpactAmbient
                      id="nao-sei-meu-cep"
                      place="top"
                      type="dark"
                      effect="solid"
                      offset={{
                        left: 10,
                        right: 10,
                        top: 10,
                        bottom: 10,
                      }}
                      arrowColor={theme.colors.blueClean}
                      backgroundColor={theme.colors.blueClean}
                      textColor={theme.colors.blue}
                    >
                      <span>
                        Clique nesse link para ser redirecionado para o site dos
                        correios e encontrar o seu CEP.
                      </span>
                    </TooltipTextImpactAmbient>
                  </TextImpactAmbient>
                </>
              )}
            </InputsContainer>

            <ButtonsContainer>
              <ContainedButton
                type="submit"
                continue
                id="Avançar"
                width="100%"
                loading={loading}
              >
                {buttonTxt}
              </ContainedButton>
            </ButtonsContainer>
          </FormContainer>
        )}
      />
      <MailingAddress
        setAddressShipLetterTo={setAddressShipLetterTo}
        openModal={openSwitchAddressModal}
        modalFunction={setOpenSwitchAddressModal}
      />
      <ModalEmailConfirm
        openModal={openEmailConfirmModal}
        modalFunction={setOpenEmailConfirmModal}
        redirectFunction={() => window.location.reload()}
        email={email}
        onlyAddress={!editForm}
      />
    </Container>
  );
};

export default BillingData;
